module.exports = __webpack_public_path__ + "media/images/icons/wiki-72fdb720b2295bddfc217f36579d3dd3.svg";